// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/electrical-fire-in-flight.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/electrical-fire-in-flight/electrical-fire-in-flight.js';

mount([g0]);
